import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6808839a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "custom-badge" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DateTimeBadge',
  props: {
    time: {}
  },
  setup(__props: any) {

const props = __props;

const isValidDate = computed(() => {
    return props.time && !isNaN(new Date(props.time).getTime());
});

const formattedDate = computed(() => {
    if (isValidDate.value) {
        const date = new Date(new Date(props.time).getTime() + new Date().getTimezoneOffset() * 60000);
        return date.toLocaleDateString('en-us', {
            weekday: "short", year: "numeric",
            month: "numeric", day: "numeric"
        });
    }
    return '';
});

const formattedTime = computed(() => {
    if (isValidDate.value) {
        const date = new Date(new Date(props.time).getTime() + new Date().getTimezoneOffset() * 60000);
        return date.toLocaleTimeString('en-us', {
            hour: 'numeric', minute: 'numeric', hour12: true
        });
    }
    return '';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    (isValidDate.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createTextVNode(_toDisplayString(formattedDate.value) + " ", 1),
          _hoisted_2,
          _createTextVNode(" " + _toDisplayString(formattedTime.value), 1)
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createTextVNode(" NA ")
        ], 64))
  ]))
}
}

})